export const TOGGLE_LOGIN_MODAL = "TOGGLE_LOGIN_MODAL";
export const DISPLAY_LOGIN_MODAL = "DISPLAY_LOGIN_MODAL";
export const HIDE_LOGIN_MODAL = "HIDE_LOGIN_MODAL";